import styled from 'styled-components'

import { getCssFromTheme } from '../../../utils/css'
import Label from '../../atoms/Label'

export const StyledLabel = styled(Label)`
  display: block;
  &.required::after {
    content: ' *';
    color: ${({ theme }) => theme.color.status.error};
  }
  &.border {
    position: absolute;
    top: -8px;
    left: 9px;
    z-index: 2;
    background-color: ${({ theme }) => theme.color.general.white};
    padding: 0 7px;
    border-radius: 7.5px;

    .hasError & {
      color: ${({ theme }) => theme.color.status.error}; // ???
    }

    .disabled & {
      color: ${({ theme }) => theme.color.general.light};
    }
  }

  &.top {
    margin-bottom: 5px;
  }

  &.required::after {
    content: ' *';
    color: ${({ theme }) => theme.color.status.error};
  }
`

export const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  width: ${({ fullWidth, width }) => width || (fullWidth && '100%')};
  height: fit-content;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.color.general.light};

  & ~ .link {
    border-radius: 7.5px;
  }

  &.withoutBorder {
    border: 1px solid transparent;
  }

  &.withInsideButtons:not(.searchInput) {
    padding-bottom: 60px;
    margin-bottom: 10px;
  }

  &.hasError {
    border: 1px solid ${({ theme }) => theme.color.status.error};
    margin-bottom: 0;
  }

  &.hasError ~ .link .label {
    color: ${({ theme }) => theme.color.status.error};
  }

  &.success {
    border: 1px solid ${({ theme }) => theme.color.status.success};
  }

  &.disabled {
    border-color: ${({ theme }) => theme.color.general.lightest};
    background-color: ${({ theme }) => theme.color.general.lightest};
    input{
      pointer-events: none;
    }
  }

  .rightIcon {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 16px;
  }

  & > .icon.leftIcon {
    position: absolute;
    top: 14px;
    left: 15px;
  }

  input {
    width: inherit;
  }

  &.selectWrapper:not(.languageSelect).focused {
    border: 1px solid ${({ theme }) => theme.color.secondary.dark};
    outline: 2px solid ${({ theme }) => theme.color.secondary.lighter};
    .label.border {
      color: ${({ theme }) => theme.color.secondary.dark} !important;
    }
    .icon:not(.statusIcon, .chevronDown, .withoutHover) path {
      stroke: ${({ theme }) => theme.color.secondary.dark};
    }
  }

  &:not(.searchInput):focus-within:not(.hasError) {
    &.inputWrapper {
      border: 1px solid ${({ theme }) => theme.color.secondary.dark};
      outline: 2px solid ${({ theme }) => theme.color.secondary.lighter};
    }

    &:not(.selectWrapper):not(.languageSelect) .icon:not(.statusIcon, .chevronDown, .withoutHover) path {
      stroke: ${({ theme }) => theme.color.secondary.dark};
    }

   &:not(.selectWrapper) .label.border {
      color: ${({ theme }) => theme.color.secondary.dark} !important;
    }

    ~ .link .label.border {
      color: ${({ theme }) => theme.color.secondary.dark} !important;
    }

    .react-select__single-value .row {
      color: ${({ theme }) => theme.color.secondary.dark};
    }

    //don't remove now, maybe we'll find new bugs without this code
    &.selectWrapper {
    //   .leftIcon path {
    //     stroke: ${({ theme }) => theme.color.general.black};
    //   }

    //   .chevronDown path {
    //     fill: ${({ theme }) => theme.color.general.black};
    //     stroke: none;
    //   }
    // }
  }
  &.hasError {
    outline: 2px solid ${({ theme }) => theme.color.status.error}40;
  }
`

export const StyledInput = styled.input`
  ${({ theme }) => getCssFromTheme(theme, 'typography', 'input')};
  flex-grow: 1;
  padding: 8px 15px;
  color: ${({ theme }) => theme.color.general.black};
  border-radius: 3px;
  min-height: 42px;
  resize: none;
  border: none;

  &.multiline {
    line-height: 22px;
  }

  &.hasLeftIcon {
    padding-left: 39px; // icon 16px + padding 15px + 8px
  }
  &.hasRightIcon {
    padding-right: 47px; // icon 15px + 2*padding 16px
  }
  &.hasError {
    padding-right: 39px;
  }

  .disabled & {
    background-color: ${({ theme }) => theme.color.general.lightest};
    color: ${({ theme }) => theme.color.general.light};
    cursor: not-allowed;
  }

  ::placeholder {
    opacity: 1;
    color: ${({ theme, placeholderColor }) => placeholderColor || theme.color.general.dark};
  }

  :-ms-input-placeholder,
  ::-ms-input-placeholder {
    /* Internet Explorer 10-11 */ /* Microsoft Edge */
    color: ${({ theme, placeholderColor }) => placeholderColor || theme.color.general.dark};
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    font-size: 16px !important;
    line-height: 20px !important;
  }
`

export const StyledButtonsRow = styled.div`
  position: absolute;
  display: flex;
  bottom: 10px;
  left: 15px;

  & > button {
    width: 26px;
    height: 26px;

    &:not(:last-child) {
      margin-right: 10px;
    }
    background-color: ${({ theme }) => theme.color.general.lightest};

    &:hover:not(.disabled) {
      background-color: ${({ theme }) => theme.color.general.lighter} !important;
    }
  }
`

export const StyledErrorLabel = styled(Label)`
  color: ${({ theme }) => theme.color.status.error};
  padding: 10px 0 12px 0;

  &:last-child {
    padding-bottom: 0;
  }

  .icon {
    margin-right: 5px;
  }
`

export const StyledInputWrapper = styled.div`
  &.isHidden {
    display: none;
  }
  &:not(:last-child) {
    margin-bottom: 20px;
  }
  &.withoutValidation {
    margin-bottom: 0;
  }

  // rich text editor
  .quill {
    width: inherit;
    height: inherit;

    .ql-toolbar {
      &.ql-snow {
        border: none;
        border-bottom: 1px solid ${({ theme }) => theme.color.general.light};
      }
    }

    .ql-container {
      &.ql-snow {
        border: none;
      }
      .ql-editor {
        word-break: break-word;
      }
    }
  }
`
